import { StyledForm, StyledFormContent, StyledFormGroup } from './Form.styles';

export type FormProps = Parameters<typeof StyledForm>[0];
export type FormContentProps = { fit?: boolean } & Omit<Parameters<typeof StyledFormContent>[0], '$fit'>;
export type FormGroupProps = Parameters<typeof StyledFormGroup>[0];

export const Form = (props: FormProps) => {
  return <StyledForm {...props} />;
};

export const FormContent = ({ fit, ...rest }: FormContentProps) => {
  return <StyledFormContent $fit={fit} {...rest} />;
};

export const FormGroup = (props: FormGroupProps) => {
  return <StyledFormGroup {...props} />;
};
